import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppSource, Content } from '@mobi/oiv-viewer-utils-ng-jslib';

import { Avb, Index } from '../../../../share/model/atomic-model';

export const oivViewerActions = createActionGroup({
    source: 'OivViewer',
    events: {
        load: props<{ urlName: string }>(),
        loaded: props<{ avbMetadata: Avb; avbChapters: Content[]; avbCoverSheet: Content }>(),
        loadFailure: props<{ error: any }>(),

        loadIndex: props<{ textReference: string; assetType: string; contentVersion: string }>(),
        loadedIndex: props<{ index: Index }>(),
        loadIndexFailure: props<{ error: any }>(),
        loadFeatures: props<{ textReference: string }>(),
        loadedFeatures: props<{ features: string[] }>(),
        loadToggleFeaturesFailure: props<{ error: any }>(),
        redirectToAppSource: props<{ sourceType: AppSource }>(),
        refresh: emptyProps(),
        avb: props<{ avb: Avb }>(),
    },
});

export const oivViewerApprovalActions = createActionGroup({
    source: 'OivViewer ApprovalMode',
    events: {
        load: props<{ urlName: string }>(),
    },
});
